define('lib/loader/series',[
  'lib/services/batws',
  'lib/page-cache',
  'lib/util/langFromUrl'
], function (
  BATWS,
  PageCache,
  langFromUrl
) {
  BATWS.cls().getSeries({ lang: langFromUrl() }).then(function (res) {
    PageCache.set('series.raw', res);
  });
});

